import { render, staticRenderFns } from "./AvatarInfo.vue?vue&type=template&id=0d7f1400&scoped=true"
import script from "./AvatarInfo.vue?vue&type=script&lang=js"
export * from "./AvatarInfo.vue?vue&type=script&lang=js"
import style0 from "./AvatarInfo.vue?vue&type=style&index=0&id=0d7f1400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7f1400",
  null
  
)

export default component.exports